import { Injectable } from "@angular/core";
import { Users } from "../models/user.model";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Blogs } from "../models/blogs.model";
import { CountryDB } from "../inmemory-db/countries";
import { of, combineLatest } from "rxjs";
import { Product } from "../models/product.model";

@Injectable()
export class FirebaseDataService {
  usersCollection: AngularFirestoreCollection<Users>;
  users: any;
  userDoc: AngularFirestoreDocument<Users>;
  id: any;

  blogsCollection: AngularFirestoreCollection<Blogs>;
  blogs: any;
  blogDoc: AngularFirestoreDocument<Blogs>;

  constructor(public afs: AngularFirestore) {
    this.usersCollection = this.afs.collection("users");
  }

  getEveryUsers() {
    this.users = this.afs
      .collection("users")
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Users;
            data.uid = a.payload.doc.id;
            return data;
          });
        })
      );

    return this.users;
  }
  getRegularinAggregate() {
    return this.afs
      .collection("users", ref => {
        return ref.where("memberType", "==", "regular");
      })
      .valueChanges();
  }
  getPlatinuminAggregate() {
    return this.afs
      .collection("users", ref => {
        return ref.where("memberType", "==", "platinum");
      })
      .valueChanges();
  }
  getVIPAggregate() {
    return this.afs
      .collection("users", ref => {
        return ref.where("memberType", "==", "vip");
      })
      .valueChanges();
  }

  getPayPalMembers() {
    this.users = this.afs
      .collection("users", ref => {
        return ref.where("options.paypalMember", "==", true);
      })
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Users;
            data.uid = a.payload.doc.id;
            return data;
          });
        })
      );

    return this.users;
  }
  getPaypalRegularLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("paypalPlan", "==", "Paypal-Three-Month-Sub-Regular");
      })
      .valueChanges();
  }

  getPaypalPlatinumLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("paypalPlan", "==", "Paypal-Three-Month-Sub-Platinum");
      })
      .valueChanges();
  }
  getPaypalVIPLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("paypalPlan", "==", "Paypal-Three-Month-Sub-VIP");
      })
      .valueChanges();
  }
  getStripeRegularLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkXKz73Kh2gQC", "==", true);
      })
      .valueChanges();
  }
  getStripePlantinumLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkYDgKcGRKQzo", "==", true);
      })
      .valueChanges();
  }
  getStripeVIPLength() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkZvgFT9HUhTB", "==", true);
      })
      .valueChanges();
  }

  getStripeMembers() {
    this.users = this.afs
      .collection("users", ref => {
        return ref.where(
          "plan_GbkXKz73Kh2gQC" ||
            "plan_GbkYDgKcGRKQzo" ||
            "plan_GbkZvgFT9HUhTB",
          "==",
          true
        );
        // .where("plan_GbkXKz73Kh2gQC", "==", true)
        // .where("plan_GbkYDgKcGRKQzo", "==", true)
        // .where("plan_GbkZvgFT9HUhTB", "==", true)
      })
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Users;
            data.uid = a.payload.doc.id;
            return data;
          });
        })
      );

    return this.users;
  }

  // Statistical data
  getRegularMemberCount() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkXKz73Kh2gQC", "==", true);
      })
      .valueChanges();
  }

  getPlatinumMemberCount() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkYDgKcGRKQzo", "==", true);
      })
      .valueChanges();
  }

  getVIPMemberCount() {
    return this.afs
      .collection("users", ref => {
        return ref.where("plan_GbkZvgFT9HUhTB", "==", true);
      })
      .valueChanges();
  }

  getUser(uid: string) {
    return this.afs
      .doc(`users/${uid}`)
      .snapshotChanges()
      .pipe(
        map(snap => {
          const data = snap.payload.data() as Users;
          const id = snap.payload.id;
          return { id, ...data };
        })
      );
  }
  getAllBlogList() {
    this.blogs = this.afs
      .collection("blogs")
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Blogs;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      );
    return this.blogs;
  }

  getPublishedBlogList() {
    this.blogs = this.afs
      .collection("blogs", ref => {
        return ref.where("publish", "==", true).where("language", "==", "japanese");
      })
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Blogs;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      );
    return this.blogs;
  }

  getEditingBlogList() {
    this.blogs = this.afs
      .collection("blogs", ref => {
        return ref.where("publish", "==", false);
      })
      .snapshotChanges()
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a.payload.doc.data() as Blogs;
            data.id = a.payload.doc.id;
            return data;
          });
        })
      );
    return this.blogs;
  }
  // get a single blog
  getSingleBlog(id) {
    return this.afs
      .doc(`blogs/${id}`)
      .snapshotChanges()
      .pipe(
        map(snap => {
          const data = snap.payload.data() as Blogs;
          const id = snap.payload.id;
          return { id, ...data };
        })
      );
  }

  // first composition of blog
  submitBlog(blog: Blogs) {
    const sharedPath = `blogs/`;
    this.afs.collection(sharedPath).add(blog);
  }
  // editing of blof
  editBlog(id, blog: Blogs) {
    this.afs.doc(`blogs/${id}`).set(blog, { merge: true });
  }

  AddService(service, userId, date) {
    const sharedPath = `users/${userId}/purchased_service/${userId}_${date}`;
    this.afs.doc(sharedPath).set(service, { merge: true });
    const sharedPathSecond = `purchased_service/${userId}_${date}`;
    this.afs.doc(sharedPathSecond).set(service);
  }
}
